import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  dismiss() {
    // Remove the element from view
    this.element.remove();

    // Store dismissal in cookie for today
    const today = new Date().toLocaleDateString('en-CA', { timeZone: 'Europe/Tallinn' }); // YYYY-MM-DD format in EET
    document.cookie = `daily_messages_dismissed=${today}; path=/; expires=${this.getEndOfDay()}`;
  }

  getEndOfDay() {
    const endOfDay = new Date();
    endOfDay.setHours(23, 59, 59, 999);
    return endOfDay.toUTCString();
  }
}
